import React, { createContext, ReactNode, useMemo } from 'react';
import RiskLevel from '@modules/openCloud/swagger/types/RiskLevel';

export interface OperationContextValue {
  operationId: string;
  method: string;
  path: string;
  url: string;
  riskLevel: RiskLevel;
  hasSupportedAuthTypes: boolean;
}

export interface OperationProviderProps {
  children: ReactNode;
  operationId: string;
  method: string;
  path: string;
  url: string;
  riskLevel: RiskLevel;
  hasSupportedAuthTypes: boolean;
}

export const OperationContext = createContext<OperationContextValue | null>(null);

export const OperationProvider: React.FC<OperationProviderProps> = ({
  children,
  operationId,
  method,
  path,
  url,
  riskLevel,
  hasSupportedAuthTypes,
}) => {
  const contextValue: OperationContextValue = useMemo(
    () => ({
      operationId,
      method,
      path,
      url,
      riskLevel,
      hasSupportedAuthTypes,
    }),
    [operationId, method, path, url, riskLevel, hasSupportedAuthTypes],
  );

  return <OperationContext.Provider value={contextValue}>{children}</OperationContext.Provider>;
};

export default OperationProvider;
